import React from 'react'

import ReactForm from './Component/ReactForm';
import "./index.css";

const App =() =>{
  return(
    <>
    <ReactForm/>

    </>
  )

}


export default App;